import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SurveyType } from '@kvika/api-types';
import { selectLang, updateLang } from '../store/lang';
import { SelectedTabType } from '../types/Types';
import { getTranslation, Lang } from '../utils/languages';
import Login from '../components/Login/Login';
import { clearAuthState } from '../store/auth';
import { clearCompanyState } from '../store/company';
import { setToken } from '../utils/authenticationStorage';

const Vendors = () => {
  const lang = useSelector(selectLang);

  const dispatch = useDispatch();
  const router = useRouter();
  const { phone } = router.query;

  useEffect(() => {
    const { lang } = router.query;
    // making sure we clean the state if a user goes to this url already logged in on some other survey
    dispatch(clearCompanyState());
    dispatch(clearAuthState());
    setToken('');

    // Setting the language
    if (lang === 'en') {
      dispatch(updateLang(Lang.EN));
    } else {
      dispatch(updateLang(Lang.IS));
    }
  }, [router.query]);

  const titlePartOneSuitabilitySurvey_string = getTranslation(lang, 'Söluaðilar', 'Vendors', '');
  return (
    <Login
      initialTabType={SelectedTabType.LEGAL_ENTITY_TYPE}
      isLegalBinder={false}
      legalBinderPhoneNumber={phone?.toString()}
      title={titlePartOneSuitabilitySurvey_string}
      surveyType={SurveyType.VendorAml}
      showTabs={false}
    />
  );
};

export default Vendors;
